import { useEffect, useState } from 'react';

function addHttpsIfNeeded(url: string) {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return 'https://' + url;
  }
  return url;
}

const useBookmarkItem = (link: string) => {
  const [host, setHost] = useState('');

  useEffect(() => {
    try {
      const url = new URL(addHttpsIfNeeded(link));
      setHost(url.hostname);
    } catch {
      setHost('');
    }
  }, [link]);

  return (
    <img
      alt="lnk-icon"
      width="16px"
      height="16px"
      src={`https://icon.horse/icon/${host}`}
    />
  );
};

export default useBookmarkItem;
